import gql from 'graphql-tag';

export const S3_file_upload_client_confirm_upload_completeMutation = gql`
  mutation S3_file_upload_client_confirm_upload_complete($full_file_key: String!, $file_size: Int!, $file_hash: String!){
    S3_file_upload_client_confirm_upload_complete(full_file_key: $full_file_key, file_size: $file_size, file_hash: $file_hash)
    {
        status
        camp_participant {
            id
            attachments {
                id
                key
                file_name
                icon_file_key
                date_created
                size
                accepted
            }
            events_array
        }
    }
}`;

export const S3_file_toggle_acceptance_flag = gql`
mutation S3_file_toggle_acceptance_flag($full_file_key: String!){
  S3_file_toggle_acceptance_flag(full_file_key: $full_file_key) {
    status
    camp_participant {
      id
      unaccepted_attachments
      attachments {
        id
        key
        file_name
        icon_file_key
        date_created
        size
        accepted
      }
      events_array
    }
  }
}`;

export const S3_file_deleteMutation = gql`mutation
  S3_file_delete($full_file_key: String!, $comment: String)
  {
    S3_file_delete(full_file_key: $full_file_key, comment: $comment)
    {
      status
      camp_participant {
          id
          unaccepted_attachments
          attachments {
            id
            key
            file_name
            date_created
            size
            accepted
          }
          events_array
        }
    }
  }`;
